import { render, staticRenderFns } from "./EditDocLabBact.vue?vue&type=template&id=4cba51fc&scoped=true"
import script from "./EditDocLabBact.vue?vue&type=script&lang=js"
export * from "./EditDocLabBact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cba51fc",
  null
  
)

export default component.exports